import { route, subGroup, meta } from '@/helpers/routes'

import DashboardProfessional from './gadget/index'
const routes = [
  route('index', ':crm/:uf', DashboardProfessional, meta('Perfil Profissional', true, 'guest'))
]

export default subGroup('/', routes)



// WEBPACK FOOTER //
// ./src/app/patient/profile-professional/routes.js